import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useCms } from "../context/CmsContext";
import SectionHead from "../components/SectionHead";
import { resolveCmsAssetUrl } from "../utils/cmsAssetUrl";
import "../partyBossTheme.css";

const CelebrationsPage = () => {
  const { cms } = useCms();
  const h = cms.home;
  const navigate = useNavigate();
  const celebrations = h.celebrations || [];
  const intro = h.celebrationsIntro || {};

  useEffect(() => {
    document.body.classList.add("party-boss-home");
    const revealOnScroll = () => {
      document.querySelectorAll(".party-boss-reveal").forEach((item) => {
        const top = item.getBoundingClientRect().top;
        if (top < window.innerHeight - 90) item.classList.add("active");
      });
    };
    revealOnScroll();
    window.addEventListener("scroll", revealOnScroll, { passive: true });
    return () => {
      document.body.classList.remove("party-boss-home");
      window.removeEventListener("scroll", revealOnScroll);
    };
  }, []);

  return (
    <div className="party-boss-page w-full overflow-x-clip bg-[#05020a] text-white selection:bg-pink-500/40">
      <div className="party-boss-bg relative z-10 pb-20">
        <SectionHead
          id={intro.id || "celebrations"}
          className="scroll-mt-28"
          eyebrow={intro.eyebrow}
          title={intro.title}
          text={intro.text}
        />
        <section className="grid gap-6 px-[5%] pb-16 md:grid-cols-2 lg:grid-cols-4 lg:px-[8%]">
          {celebrations.map((card) => (
            <div
              key={card.title}
              className="party-boss-celebration-card party-boss-reveal relative min-h-[330px] overflow-hidden rounded-[34px] border border-white/15 shadow-2xl transition duration-500"
            >
              <img
                src={resolveCmsAssetUrl(card.imageUrl || card.image)}
                alt={card.title}
                className="h-full w-full object-cover transition duration-700 hover:scale-110"
              />
              <div className="absolute bottom-6 left-6 right-6 z-20">
                <h2 className="mb-2 text-xl font-black">{card.title}</h2>
                <p className="text-sm leading-6 text-white/80">{card.text}</p>
              </div>
            </div>
          ))}
        </section>
        <div className="flex justify-center px-[5%]">
          <button
            type="button"
            onClick={() => navigate("/booknow")}
            className="rounded-full bg-gradient-to-r from-pink-500 to-violet-600 px-8 py-3 text-sm font-black text-white shadow-xl md:text-[15px]"
          >
            {h.hero?.primaryCta || "Book Theatre Now"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CelebrationsPage;
